import React from 'react';
import NewJobFormField from './NewJobFormField/NewJobFormField';

const NewJobForm = ({ formData, setFormData, containerGap }) => {
    return (
        <>
            {!!formData?.length && (
                <div className="flex flex-col" style={{ gap: `${containerGap}px` }}>
                    {formData.map((input) => (
                        <NewJobFormField
                            key={input.key}
                            input={input}
                            setFormData={setFormData}
                            withActionButtons={false}
                        />
                    ))}
                </div>
            )}
        </>
    );
};

export default NewJobForm;
